import React from "react";
import CompareOriginalVsCompressed from "components/features/CompressorCommon/CompareOriginalVsCompressed";

import BestUsageForPngCompressorSection from "components/features/PngCompressor/BestUsageForPngCompressorSection";
import PngCompressorFaq from "components/features/PngCompressor/PngCompressorFaq";
import { WeSupportBulkImageCompressionSection } from "components/features/CompressorCommon/WeSupportBulkImageCompressionSection";

const PngCompressorPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <CompareOriginalVsCompressed
                    originalSizeInKb={1024}
                    compressedSizeInKb={485}
                    imageSrc1="/images/original_vs_compressed_org.png"
                    imageSrc2="/images/original_vs_compressed_com.png"
                />
                <WeSupportBulkImageCompressionSection />
                <BestUsageForPngCompressorSection />
                <PngCompressorFaq />
            </div>
        </div>
    );
};

export default PngCompressorPreToolsArea;
